export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.7fccb5c8.svg";